<script setup lang="ts">
    // import { b } from 'node_modules/vite/dist/node/types.d-aGj9QkWt';
import { ref, defineAsyncComponent } from 'vue';

    // Props
    const props = withDefaults(defineProps<{
        id: string
        onInput?: Function
        onBlur?: Function
        onChange?: Function
        inputLabel?: string
        placeholder?: string
        type?: string
        errors?: string | null
        value: boolean
        classes?: any[]
        disabled?: boolean,
        isFromPs?: boolean,
        userSizedClass?: boolean
    }>(), {
        type: 'text',
        errors: null,
        disabled: false,
        isFromPs:false,
        userSizedClass: false,
    })

    // Emits
    const emit = defineEmits(['update:value'])

    // Refs
    const isChecked = ref(props.value)

    // Functions
    const handleChange = () => {
      isChecked.value = !isChecked.value;
      emit('update:value', isChecked.value)
    };

    const Close = defineAsyncComponent(() => import('vue-material-design-icons/Close.vue'))
    const Check = defineAsyncComponent(() => import('vue-material-design-icons/Check.vue'))

</script>

<template>
    <label 
        class="form-check-label fw-bolder me-2 d-flex align-items-center"
        :class="{'normal-text': props.isFromPs, 'sized-text-checker': props.userSizedClass}" 
        :for="props.id">{{ props.inputLabel }}</label>
    <div class="form-check form-switch form-check-primary">
        <input
            type="checkbox" 
            class="form-check-input"
            :class="{ 'form-check-input-from-ps': props.isFromPs }"
            :disabled="props.disabled"
            :checked="isChecked"
            @change="handleChange"
            :id="props.id"
         />
        <label 
            class="form-check-label d-flex justify-content-center align-items-center" 
            :for="props.id">
            <span class="switch-icon-left"><check :size="23"></check></span>
            <!-- <span class="switch-icon-right"><close :size="18"></close></span> -->
        </label>
    </div>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
.normal-text{
    font-weight: normal !important;
    font-size: 10px;
}
.form-check-input-from-ps:checked {
    background-color: #59b4cd !important;
}
.form-check-input {
    width: 4.5rem;
    height: 1.9rem !important;
}

.form-check-input:hover {
    cursor: pointer;
}

.switch-icon-right {
    /* margin-top: 3px; */
    bottom: 35px !important;
    left: 35px !important;
    top : 3px !important;
}

.switch-icon-left {
    /* margin-top: 3px; */
    right: 3;
    top : 3px !important;
}

.sized-text-checker {
    font-size: 15px !important;
}


</style>